import LanguageList from "../../../../../../shared/components/language/LanguageList";
import { SETTINGS_CONTENT_NAMES } from "../../../../types/enums";
import SettingsControlsContentWrapper from "./SettingsControlsContentWrapper";

interface ILanguageSettings {
  setSettingsContent: (newContent: SETTINGS_CONTENT_NAMES) => void;
}

const LanguageSettings = ({ setSettingsContent }: ILanguageSettings) => {
  return (
    <SettingsControlsContentWrapper onGoBackButton={setSettingsContent}>
      <LanguageList />
    </SettingsControlsContentWrapper>
  );
};

export default LanguageSettings;
